export default __webpack_public_path__ + "static/media/man2.7ed4be39.jpg";